export default "__VITE_ASSET__CvlB5JL6__"